// Deep-link: канон пути в SPA до конкретного сообщения. SPEC pwa-shell §4.5; правка L (CONTRACTS).
//
// Канон — `/chat/<chatId>?msg=<messageId>` (MESSAGE-id, НЕ seq: правка L снимает конфликт
// notifications-push↔app-ui). Эти функции — единственный носитель формы deep-link на фронте:
// `notifications-push` кладёт готовый `deepLink` в PushPayload, а pwa-shell его не выдумывает —
// но round-trip-парс/сбор нужен, чтобы (а) валидировать форму и (б) собирать ссылку там, где
// payload пришёл без неё (деградация §4.9). Чистые, тестируются в Node без браузера.
/** Корень списка чатов — единственный допустимый «без конкретного сообщения» путь (деградация §4.9). */
export const CHATS_ROOT = '/chat';
/**
 * Собирает канонический deep-link. `/chat/<chatId>?msg=<messageId>` (правка L).
 * Компоненты URL-кодируются — id в проде UUID, но кодирование держит инвариант формы строго.
 */
export function buildDeepLink(chatId, messageId) {
    const chat = encodeURIComponent(chatId);
    const msg = encodeURIComponent(messageId);
    return `${CHATS_ROOT}/${chat}?msg=${msg}`;
}
/**
 * Разбирает deep-link в цель навигации. Принимает как путь (`/chat/<id>?msg=<id>`), так и
 * абсолютный URL (тот же путь под любым origin — на клик из SW origin наш). Возвращает `null`,
 * если путь не наш (не `/chat/<chatId>`), чтобы вызывающий мог уйти в дженерик-деградацию (§4.9),
 * а не молча навигировать «в никуда».
 */
export function parseDeepLink(url) {
    // База нужна только для парса относительного пути; сам origin не используется (берём pathname/search).
    let parsed;
    try {
        parsed = new URL(url, 'https://pwa.local');
    }
    catch {
        return null;
    }
    // Ожидаем ровно /chat/<chatId> (возможен trailing slash). Сегменты после <chatId> игнорируем —
    // якорь сообщения несёт query `msg`, а не путь (канон правки L).
    const segments = parsed.pathname.split('/').filter((s) => s.length > 0);
    if (segments.length < 2 || segments[0] !== 'chat')
        return null;
    const chatId = decodeURIComponent(segments[1]);
    if (chatId.length === 0)
        return null;
    const rawMsg = parsed.searchParams.get('msg');
    const messageId = rawMsg !== null && rawMsg.length > 0 ? rawMsg : undefined;
    return messageId !== undefined ? { chatId, messageId } : { chatId };
}
/** true, если deep-link ведёт в КОНКРЕТНОЕ сообщение (носитель инв.1, а не «просто открыть чаты»). */
export function pointsToMessage(url) {
    const target = parseDeepLink(url);
    return target !== null && target.messageId !== undefined;
}
//# sourceMappingURL=deep-link.js.map